import { Box, Button } from "@mui/material";
import { brandingConstants } from "../../../../PreviewStyles/constants";
import { handleFontPreview } from "../../../helpers";

interface IProps {
  previewAgent: boolean;
  branding: any;
  technology: string | undefined;
  page: number;
}

const QRButtons = ({ previewAgent, branding, technology, page }: IProps) => {
  return (
    <Box display="flex" justifyContent="center">
      <Button
        variant="contained"
        sx={{
          boxShadow: "none",
          backgroundColor: branding?.[brandingConstants.primaryButtonBGColor],
          color: branding?.[brandingConstants?.primaryButtonTextColor],
          minWidth: previewAgent ? "200px" : "100px",
          fontSize: handleFontPreview(
            branding?.[brandingConstants.primaryButtonFontSize],
            previewAgent
          ),
          fontFamily: branding?.[brandingConstants.primaryButtonFontFamily],
          fontWeight: "700",
          marginRight: previewAgent ? "30px" : "3px",
          fontStyle: branding?.[brandingConstants.primaryButtonFontStyle],
          border: `1px solid ${
            branding?.[brandingConstants.primaryButtonBorderColor]
          }`,
          borderRadius:
            technology !== "rokuTv"
              ? branding?.[brandingConstants.primaryButtonBorderRadius]
              : "0px",
          "&:hover": {
            backgroundColor: branding?.[brandingConstants.primaryButtonBGColor],
            boxShadow: "none",
          },
        }}
      >
        Close
      </Button>

      <Button
        variant="contained"
        sx={{
          boxShadow: "none",
          backgroundColor: branding?.[brandingConstants.secondaryButtonBGColor],
          color: branding?.[brandingConstants?.secondaryButtonTextColor],
          minWidth: previewAgent ? "200px" : "100px",
          minHeight: previewAgent ? "50px" : "20px",
          fontSize: handleFontPreview(
            branding?.[brandingConstants.secondaryButtonFontSize],
            previewAgent
          ),
          fontFamily: branding?.[brandingConstants.secondaryButtonFontFamily],
          fontWeight: "700",
          fontStyle: branding?.[brandingConstants.secondaryButtonFontStyle],

          border: `1px solid ${
            branding?.[brandingConstants.secondaryButtonBorderColor]
          }`,
          borderRadius:
            technology !== "rokuTv"
              ? branding?.[brandingConstants.secondaryButtonBorderRadius]
              : "0px",
          "&:hover": {
            backgroundColor:
              branding?.[brandingConstants.secondaryButtonBGColor],
            boxShadow: "none",
          },
        }}
      >
        Back
      </Button>
    </Box>
  );
};

export default QRButtons;
